import "./card.css";

interface Props {
  title: string;
  number: string | number;
  isActive?: boolean;
}

const CreditCard = ({ title, number, isActive }: Props) => {
  return (
    <div className="credit_dashboardCardWrapper">
      <div className="credit_card_holder">
        <div className="card_details">
          <span className="card_title">{title}</span>
          <span className="card_number">{number}</span>
        </div>
        {isActive && <div className="active_holder">Active</div>}
      </div>
    </div>
  );
};

export default CreditCard;
